import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import ParametersHeader from "../ParametersHeaders";
import AtmCompanies from "./AtmCompanies/AtmCompanies";
import AtmModels from "./AtmModels/AtmModels";
import AtmServiceProviders from "./AtmServiceProviders/AtmServiceProviders";
import AtmTypes from "./AtmTypes/AtmTypes";


const ATM = () =>{
  
    const chipHeaders = ["Εταιρίες", "Μοντέλα", "Τύποι", "ATM Service Providers"];
    const chipItems: React.ReactNode[] = [
      <AtmCompanies/>,
      <AtmModels />,
      <AtmTypes />,
      <AtmServiceProviders />,
    ];
  
    return (
      <div className="page-content">
        <ParametersHeader />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default ATM